<template><div>
  <v-row class="pa-0 ma-0">
    <v-col cols="12" sm="6" 
      v-if="enable_account_types && this.currentCompany['companydb_type'].value != 'diezsoftware_nube_au'" 
      :class="enable_account_types && this.currentCompany['companydb_type'].value!='diezsoftware_nube_au' && $vuetify.breakpoint.smAndUp ? 'pa-0 ma-0 pr-4' : 'pa-0 ma-0'"
    >
      <app-select
        v-model="account_type"
        label="Tipo de cuenta"
        :items="account_types"
        :hide-details="true"
        class="pt-0 mt-0 rounded-lg app-select-no-border"
        @change="fillAccountByType"
      ></app-select>
    </v-col>
    <v-col 
      :cols="(enable_account_types && this.currentCompany['companydb_type'].value!='diezsoftware_nube_au' && $vuetify.breakpoint.smAndUp)?'6':'12'" 
      :class="enable_account_types && this.currentCompany['companydb_type'].value!='diezsoftware_nube_au' && $vuetify.breakpoint.smAndUp ? 'pa-0 ma-0 pl-4' : 'pa-0 ma-0'"
    >
      <div v-if="kind=='boolean'">
        <v-checkbox v-if="!(myValue===undefined)" 
          :input-value="myValue"
          :value="myValue"
          :true-value="false"
          :false-value="true"
          @change="myInput"
          style="margin-top:0px" class="" 
          :disabled="disabled"
          hide-details 
          :dense="dense"
        >
        </v-checkbox>
        <v-checkbox v-else 
          :input-value="false"
          :value="myValue"
          :true-value="false"
          :false-value="true"
          @change="myInput"
          style="margin-top:0px" class="" 
          :disabled="disabled"
          hide-details 
          :dense="dense"
        >
        </v-checkbox>
      </div>
      <app-combobox
        v-else-if="kind=='account_am'"
        :error="(bck_error || computedError || error)"
        :value="myValue"
        @change="myChange"
        :readonly="Boolean(readonly)"
        :required="required"
        autocomplete="off"
        @input="myInput"
        @mouseup="setFocused"
        :label="label"
        :dense="dense"
        :hide-details="myHideDetails"
        :disabled="disabled"
        :class="computedClass"
        :rules="myRules"
        :items="items"
        item-text="account"
        item-value="account"
        append-icon=""
        :filter="filterBy"
        @input.native="myNativeInput"
        @click="myClick"
        @blur="myBlur"
        @keydown="handleKeyDown"
        :errorMessages="errorMessages"
        >
        <template slot="item" slot-scope="data">
          {{ data.item.account }} - {{ data.item.description }}
        </template>
      </app-combobox>
      <app-text-field
        v-else
        autocomplete="off"
        :value="myValue"
        :label="label"
        :error="(bck_error || computedError || error)"
        :readonly="Boolean(readonly)"
        :required="required"
        :dense="dense"
        :hide-details="hideDetails"
        :disabled="disabled"
        :hint="hint"
        :class="computedClass"
        :rules="myRules"
        :append-icon="appendIcon"
        :append-icon-tooltip-text="appendIconTooltipText"
        :error-messages="errorMessages"
        :type="type"
        @change="myChange"
        @focus="setFocused"
        @input="myInput"
        @click:append="e => $emit('click:append', e)"
        @keydown="handleKeyDown"
      ></app-text-field>
        <!--TODO: Revisar app-text-field :type="kind" -->
    </v-col>
  </v-row>

     <!-- @hide-details="setHideDetails" -->

  </div>
</template>

<script>
import {mapGetters, mapState, mapActions} from "vuex"
import { bus } from '@/main.js'
import { client } from "@/api/client"
import {round, isValidDate} from '@/utils'
import { validateAccount } from "@/utils/account_validation"
import {evaluate} from 'mathjs'
import { isValidAccountNumberDigits } from "@/modules/accounts/domain/AccountNumberDigits"
import { isValidConceptMaxDigits } from "@/modules/concepts/domain/Concept"
import { numDigitIsMinMustBeApplied } from "@/modules/accounts/domain/Account"
import AppTextField from '@/components/layout/AppTextField.vue';
import AppCombobox from '@/components/layout/AppCombobox.vue';
import AppSelect from '@/components/layout/AppSelect.vue';

export default {
  name: 'AppDocTextField',

  components: {
    AppTextField,
    AppCombobox,
    AppSelect,
  },

  props: {
      appendIcon: {
        type: String,
        default: ''
      },
      appendIconTooltipText: {
        type: String,
        default: ''
      },
      hideDetails: {
        type:Boolean,
        default: false,
      },
      label:String, 
      readonly: {type:[Boolean,String,Number], default:false},
      required: {type:Boolean, default:false},
      value:[String,Number,Array,Boolean],
      small_font:{type:Boolean, default:false},
      disabled:{type: Boolean, default: false},
      fieldClass:{type:Object, default:function(){ return {}}},
      kind:{
        type:String,
        default: 'text', //account, account_am, number, text, date
      },
      items: {
        type: Array,
        default: function () {
                return [];
            },
        required: false
      },
      error: {type:Boolean, default:false},
      errorMessages: {
        type: [String, Array],
        default: () => []
      },
      initial_error: {type:Boolean, default:false},
      startzeroable: {type:Boolean, default:false},
      digits: [Number, Boolean],
      errorColor: {type:String, default:'#ff9898'},
      font_weight_black: {type:Boolean, default:false},
      primary_color_text: {type:Boolean, default:false},
      right_input: {type:Boolean, default: false},
      dense: {type:Boolean, default:false},
      is_table: {
        type:Boolean,
        default: false,
        required: false,
      },
      is_array: {
        type: Boolean,
        default: false
      },
      num_digits: {
        type: [Number, Boolean],
        default: false
      },
      third: {type:String, default:''},
      enable_account_types: {
        type: Boolean,
        default: false
      },
      max_length_account:{
        type: [Number, Boolean],
        default: false,
      },
      account_types: {
        type: Array,
        default: function () {
          return [];
        },
      },
      hint: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'text'
      },
      account_prefix_filter: {
        type: String,
        default: ''
      },
  },
  data() {
    return {
      hasFocus:false,
      myValue:undefined,
      myRules: undefined,
      myHideDetails: false,
      bck_error:this.initial_error,
      account_type:'',
    };
  },
  created() {
    // if(this.kind==='number' && this.value!=undefined){
    //   try{
    //     this.myValue=round(this.myParseFloat(this.value))
    //   }catch(err){
    //     this.myValue=this.value
    //   }
    // } else {
      // if (this.kind === 'account'){
      //   this.myRules = this.accountRules;
      //   //this.myHideDetails = false;
      // } 
      this.myValue=this.value
    // }
  },
  destroyed(){
      if(this.hasFocus){
          this.unsubscribe()
      }
    
  },
  computed:{
    computedClass(){
      var result = {}
      Object.assign(result, this.fieldClass);
      if(this.kind==='number'|| this.right_input){
        result['right-input']=true
      }else{
        result['left-input']=true
      }
      if (this.font_weight_black) {
        result['font-weight-black']=true
      }
      if (this.primary_color_text) {
        result['primary-color-text']=true
      }
      if (this.is_table) {
        result['mt-0']=true
        if(this.error) {
          result['background-color']=this.errorColor
        }
      }
      if (this.small_font) {
        result['small-font'] = true
      }

      return result
    },
    computedError(){
      let error=false
      if(this.kind==='number'){
        let v = this.myValue;
        if(this.startzeroable){
          if(v && v[0]=='0'){
            v = v.substring(1)
          }
        }
        if(v!=undefined){
          v=v.toString().toLowerCase().replace(/,/g,'.').replace('€','').replace('$','').replace('eur','')
          try{
            evaluate(v)
          }catch(err){
            error=true
          }
        }
      }
      if(this.required){
        if(this.myValue==='' || this.myValue===undefined){
          error=true
        }
        if(this.kind==='date'){
          error = !isValidDate(this.myValue)
        }
      }
      if(this.kind==='type_iva'){
        if(this.myValue!==undefined && this.myValue!=='')
        if(!this.isNumber(this.myValue))
          error=true
      }
      if(this.kind === "special_acc" ) {
        if(!RegExp(this.currentCompany['companydb_type']['params']['accounts_format']).test(this.myValue)){
          error = true;
        }
      }
      if(['account', 'account_am'].includes(this.kind) && this.num_digits && this.currentCompany.companydb_type.value!='diezsoftware_nube_au'){
        let num_digit_is_max_length = this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params['num_digit_is_max_length']
        let num_digit_kind = 'exact'
        if(num_digit_is_max_length){
          num_digit_kind = 'max'
        }
        if(numDigitIsMinMustBeApplied(this.currentCompany, this.userData)){
          num_digit_kind = 'min'
        }
        if (this.is_array) {
          let aux = [];
          if (typeof this.myValue === 'string' || this.myValue instanceof String) {
            aux = this.myValue.replaceAll(' ', '').split(',');
          } else {
            aux = this.myValue;
          }
          for (let i in aux) {
            if (aux[i]){
              if(!isValidAccountNumberDigits(aux[i], this.num_digits, num_digit_kind)){
                error = true;
              }
            } 
          }
        } else if(!(this.currentCompany && this.currentCompany.companydb_type.params.hasOwnProperty('cif_in_account'))){
          if (this.myValue){
            if(!isValidAccountNumberDigits(this.myValue, this.num_digits, num_digit_kind)){
                error = true;
            }
          }
        }
      }
      else if(['account', 'account_am'].includes(this.kind) && this.max_length_account){
        if (this.is_array) {
          let aux = [];
          if (typeof this.myValue === 'string' || this.myValue instanceof String) {
            aux = this.myValue.replaceAll(' ', '').split(',');
          } else {
            aux = this.myValue;
          }
          for (let i in aux) {
            if (aux[i]){
              if(!isValidConceptMaxDigits(aux[i], this.max_length_account)){
                error = true;
              }
            }
          }
        } 
      }
      return error
    },
    ...mapGetters({currentCompany:'getCurrentCompany',
                  userData: "me/userData",}),
    accountRules() {
      return [
        (v) => !v || validateAccount(v) || 'La cuenta debe contener únicamente dígitos'
      ]
    }
  },
  methods:{
      setFocused(value){
        bus.$emit('other-focused')
        setTimeout(()=>{
          this.hasFocus=true
          bus.$on('document-text-clicked',this.textClicked)
          bus.$on('other-focused',this.otherFocus)
          
        })
        this.$emit('focus',value)
      },
      setHideDetails(value){
        this.$emit('hide-details', value)
      },
      unsubscribe(){
        bus.$off('document-text-clicked',this.textClicked)
        bus.$off('other-focused',this.otherFocus)
      },
      handleKeyDown(e) {
        if (e.ctrlKey) return
        switch(e.keyCode) {
          case 13:
            this.enterPressed()
            break
          default:
            break
        }
      },
      otherFocus(){
          this.hasFocus=false
          this.unsubscribe()
      },
      changeObjectToString(value) {
        let val = "";
        if (Array.isArray(value)) {
          val = [];
          for (let i in value) {
            if (value[i]['account']) {
              val.push(value[i]['account'])
            } else {
              val.push(value[i])
            }
          }
        } else if (typeof value === "object") {
          val = value.account;
        } else {
          val = value;
        }
        return val;
      },
      myInput(value) {
          let val = value;
          if (this.kind=='account_am') {
            val = this.changeObjectToString(value);
          }
          this.myValue = val;
          this.$emit('input', val);
      },
      myChange(value) {
          let val = value;
          if (this.kind=='account_am' ) {
            val = this.changeObjectToString(value);
            let params = {'companydb_id': this.currentCompany.id, 'text': value};
            if (this.account_prefix_filter) {
              params['prefix_filter'] = this.account_prefix_filter;
              params['use_no_limit'] = true; // Usar accounts_all para selectores <- solo se está activando cuando account_prefix_filter, i.e. cuando estimasol, esitmasol_nube, aplifisa_fiscal.
            }
            this.getAccounts(params)
          }
          this.myValue = val;
          this.$emit('change', val);
      },
      myClick(){
        if (this.kind=='account_am' ) {
          let params = {'companydb_id': this.currentCompany.id, 'text': this.myValue};
          if (this.account_prefix_filter) {
            params['prefix_filter'] = this.account_prefix_filter; //mateix arguments que a DocTextField.vue
            params['use_no_limit'] = true;
          }
          this.$emit('get-values', params);
        }
      },
      myNativeInput(value) {
        let params = {'companydb_id': this.currentCompany.id, 'text': value.target.value};
        if (this.account_prefix_filter) {
          params['prefix_filter'] = this.account_prefix_filter;
          params['use_no_limit'] = true;
        }
        this.$emit('get-values', params);
        this.myInput(value.target.value);
      },
      myBlur() {
          this.$emit('reset-items', []);
      },
      textClicked(value){
          if(this.hasFocus){
            if(!this.myValue){
              this.myValue=value
            }else{
              let sepSymbol=this.kind==='number'?'+':' '
              this.myValue+=sepSymbol+value
            }
          }
          this.$emit('input',this.myValue)
          
      },
      enterPressed(){
        if(['account', 'account_am'].includes(this.kind)) {
          this.fillAccount();
        }else if(this.kind==='number'){
          var ev=this.myValue.toString().toLowerCase().replace(/,/g,'.').replace('€','').replace('$','').replace('eur','')
          try {
            var newValue=round(evaluate(ev),2)
          }
          catch(err) {
            var newValue=ev;
          }
          if(newValue){
            this.myValue=newValue
            this.$emit('input',this.myValue)
          }
        }
      },
      fillAccount(){
        let targetLength=this.currentCompany.num_digits
        if(this.num_digits){
          targetLength=this.num_digits
        }
        if(this.digits){
          targetLength=this.digits
        }
        if((this.myValue.toString().match(/\./g) || []).length==1 && 
           this.myValue.length<=targetLength
           ){
          if (!(this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.interrogante_id_tercero)) {
            const autocomplete = () => {
              let pos=this.myValue.indexOf('.')
              let left=this.myValue.substring(0,pos)
              let right=this.myValue.substring(pos+1)
              this.myValue=left+'0'.repeat(targetLength-this.myValue.length+1)+right
              this.$emit('input', this.myValue)
            }
            setTimeout(autocomplete, 100)
          }
        }else if(this.currentCompany.companydb_type.value === 'sage_addon' ? this.myValue.match(/^(523|521|440|430|410|400|173)[0-9]*\?$/) : this.myValue.match(/^(523|440|430|410|400|173)[0-9]*\?$/)){
          if (!(this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.interrogante_id_tercero)) {
            client.get(`get_next_account/${this.currentCompany.id}/${this.myValue.substr(0,this.myValue.length-1)}/`).then(result=>{
              this.myValue=result.data.next_account
              this.$emit('input',this.myValue)
            })
          }
        } else if(this.myValue==='?' && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.interrogante_id_tercero) {
          if(this.third!='' && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.get_next_account_not_global){
            client.get(`get_next_account_id/${this.currentCompany.id}/${this.third}/`).then(result=>{
              this.myValue=result.data.next_account
              this.$emit('input',this.myValue)
            })
          }
          else{
            client.get(`get_next_account_global/${this.currentCompany.id}/`).then(result=>{
              this.myValue=result.data.next_account
              this.$emit('input',this.myValue)
            })
          }
          
        }
      },
      fillAccountByType() {
        this.myValue = this.account_type;
        this.fillAccount();
      },
      isNumber(s){
        var floatRegex = /^-?\d+(?:[.,]\d*?)?$/;
        if (!floatRegex.test(s))
            return false;

        s = parseFloat(s);
        if (isNaN(s))
            return false;
        return true;
      },
      filterBy(item, queryText, itemText) {
        const text = item.account.toLowerCase() + ' - ' + item.description.toLowerCase();
        const searchText = queryText.toLowerCase();
        return text.indexOf(searchText) > -1;
      },
      ...mapActions("cru", ['getAccounts']),
  },
  watch:{
    value(newVal, oldVal) {
      let val = newVal;
      if (this.kind=='account_am') {
        val = this.changeObjectToString(newVal);
      }
      this.myValue = val;
    }
  }

};
</script>

<style scoped>
.primary-color-text >>> input {
      color: var(--v-primary-base) !important;
}
.small-font >>> input {
      font-size:small;
      margin-left: 5px;
}
</style>
